import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export const DRAWER_WIDTH = 300;
const drawerTopMargin = 8;

export const Main = styled('main', {
	shouldForwardProp: prop => prop !== 'open',
})(({ theme, open }) => ({
	flexGrow: 1,
	padding: theme.spacing(3),
	transition: theme.transitions.create('margin', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	marginRight: open ? -DRAWER_WIDTH : 0,
	width: open ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%',
	...(open && {
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginRight: 0,
	}),
	/**
	 * This is necessary to enable the selection of content. In the DOM, the stacking order is determined
	 * by the order of appearance. Following this rule, elements appearing later in the markup will overlay
	 * those that appear earlier. Since the Drawer comes after the Main content, this adjustment ensures
	 * proper interaction with the underlying content.
	 */
	position: 'relative',
}));

export const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: theme.spacing(0, 1),
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
	justifyContent: 'flex-start',
}));

const HelpBar = ({ open, sxPaper = {}, setOpen, ...props }) => {
	const theme = useTheme();

	const handleDrawerClose = () => {
		setOpen(false);
	};

	return (
		<Drawer
			sx={theme => ({
				width: DRAWER_WIDTH,
				marginTop: drawerTopMargin,
				flexShrink: 0,
				'& .MuiDrawer-paper': {
					width: DRAWER_WIDTH,
					marginTop: drawerTopMargin,
					height: `calc(100% - ${theme.spacing(drawerTopMargin)})`,
					...sxPaper,
				},
			})}
			variant='persistent'
			anchor='right'
			open={open}
		>
			<DrawerHeader>
				<IconButton onClick={handleDrawerClose}>
					{theme.direction === 'rtl' ? (
						<ChevronLeftIcon />
					) : (
						<ChevronRightIcon />
					)}
				</IconButton>
				Close
			</DrawerHeader>
			<Divider />
			<Box sx={{ padding: 2 }}>{props.children}</Box>
		</Drawer>
	);
};

export default HelpBar;
